"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noOneChildOfSpecificTag = exports.everyChildOfSpecificTag = exports.numberOfSpecificTag = void 0;

/**
 * Function to dive into jsx Node to search a specific Tag.
 * @param {string} tagName Tag to search
 * @param {jsxNode} jsxNode jsx node where search it's gonna take place
 * @param {bool} directChildren True to dive only into directChildren or false otherwise
 * @returns {int} Number ot tags found.
 */
var numberOfSpecificTag = function numberOfSpecificTag(tagName, jsxNode) {
  var initialEntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var childTags = 0;
  var internalTags = 0;

  if (Array.isArray(jsxNode)) {
    jsxNode.forEach(function (child) {
      if (child.type && (child.type === tagName || child.type.name === tagName)) {
        childTags += 1;
      } else if (child.props && child.props.children) {
        var auxTagNumber = numberOfSpecificTag(tagName, child.props.children, false);

        if (initialEntry) {
          internalTags += auxTagNumber.childTags;
        } else {
          childTags += auxTagNumber.childTags;
        }
      }
    });
  } else if (jsxNode && jsxNode.type && (jsxNode.type === tagName || jsxNode.type.name === tagName)) {
    childTags += 1;
  }

  return {
    childTags: childTags,
    internalTags: internalTags
  };
};
/**
 * Function to dive into jsx Node and determine when every child has same tagName and match with one specified by param.
 * @param {string} tagName Tag to search
 * @param {jsxNode} jsxNode jsx node where search it's gonna take place
 * @returns {bool} True if every child has same tag.
 */


exports.numberOfSpecificTag = numberOfSpecificTag;

var everyChildOfSpecificTag = function everyChildOfSpecificTag(tagName, jsxNode) {
  var childTags = 0;
  var everyChildSameTag = false;

  if (Array.isArray(jsxNode)) {
    jsxNode.forEach(function (child) {
      if (child.type && (child.type === tagName || child.type.name === tagName)) {
        childTags += 1;
      }
    });

    if (jsxNode.length === childTags) {
      everyChildSameTag = true;
    }
  } else if (jsxNode && jsxNode.type && (jsxNode.type === tagName || jsxNode.type.name === tagName)) {
    everyChildSameTag = true;
  }

  return everyChildSameTag;
};
/**
 * Function to dive into jsx Node and determine when no one child has tagName and match with one specified by param.
 * @param {string} tagName Tag to search
 * @param {jsxNode} jsxNode jsx node where search it's gonna take place
 * @returns {bool} True if no one child has specified tag.
 */


exports.everyChildOfSpecificTag = everyChildOfSpecificTag;

var noOneChildOfSpecificTag = function noOneChildOfSpecificTag(tagName, jsxNode) {
  var noOneChildSpecificTag = true;

  if (Array.isArray(jsxNode)) {
    jsxNode.forEach(function (child) {
      if (child.type && (child.type === tagName || child.type.name === tagName)) {
        noOneChildSpecificTag = false;
      }
    });
  } else if (jsxNode && jsxNode.type && (jsxNode.type === tagName || jsxNode.type.name === tagName)) {
    noOneChildSpecificTag = false;
  }

  return noOneChildSpecificTag;
};

exports.noOneChildOfSpecificTag = noOneChildOfSpecificTag;

//# sourceMappingURL=index.js.map